module.exports = __webpack_public_path__ + "static/media/family.4a3eeb78.webp";